import { ICButton, ICModal } from "../../core-component/ui";
import UseTranslationHook from "../../hooks/UseTranslationHook";

interface IDeleteBlockedModalProps {
  title: string;
  message: string;
  onMakeInactive?: () => void;
  onClose: () => void;
}

const DeleteBlockedModal: React.FC<IDeleteBlockedModalProps> = ({
  title,
  message,
  onMakeInactive,
  onClose,
}) => {
  const { t } = UseTranslationHook();

  return (
    <ICModal title={title} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <div>{message}</div>
        <div className="text-sm text-muted">{t("delete_blocked_hint")}</div>
        <div className="flex justify-center gap-5">
          {onMakeInactive && (
            <ICButton type="button" className="!w-fit" onClick={onMakeInactive}>
              {t("make_inactive")}
            </ICButton>
          )}
          <ICButton
            type="button"
            className="!bg-danger-muted !text-danger w-20"
            onClick={onClose}
          >
            {t("ok")}
          </ICButton>
        </div>
      </div>
    </ICModal>
  );
};

export default DeleteBlockedModal;
